import React from "react";
import {
  Button,
  Text,
  Modal,
  ModalContent,
  ModalFooterButtons,
} from "@reside/ui";

type Props = Readonly<{
  residentName: string;
  isOpen: boolean;
  isLoading: boolean;
  onRequestClose: () => void;
  onArchive: () => void;
}>;

export const ArchiveModal = ({
  residentName,
  isOpen,
  isLoading,
  onArchive,
  onRequestClose,
}: Props) => (
  <Modal
    isOpen={isOpen}
    onRequestClose={onRequestClose}
    title={`Archive Admission for ${residentName}`}
  >
    {({closeModal}) => (
      <>
        <ModalContent>
          <Text as="p">
            Do you really wish to archive this admission? The changes are
            irreversible.
          </Text>
        </ModalContent>
        <ModalFooterButtons>
          <Button color="primary" outline onClick={closeModal}>
            Cancel
          </Button>
          <Button color="danger" disabled={isLoading} onClick={onArchive}>
            {isLoading ? "Archiving..." : "Archive"}
          </Button>
        </ModalFooterButtons>
      </>
    )}
  </Modal>
);
